import { Component } from "react"
import "./ValuationLoader.css"

const LOADING_MESSAGES = [
    "Analysing comparable sales",
    "Crunching the numbers",
    "Scanning the neighbourhood",
    "Cross-referencing sale prices",
    "Evaluating market trends",
    "Factoring in location data",
    "Reviewing recent transactions",
    "Calibrating price model",
    "Assessing local demand",
    "Computing valuation range",
    "Weighing property features",
    "Mapping nearby sold homes",
]

const LOADING_STEPS = [
    "Comparable sales",
    "Local demand",
    "Market range",
]

interface ValuationLoaderState {
    messageIndex: number
}

class ValuationLoader extends Component<{}, ValuationLoaderState> {
    private interval: NodeJS.Timeout | null = null

    constructor(props: {}) {
        super(props)
        this.state = {
            messageIndex: Math.floor(Math.random() * LOADING_MESSAGES.length),
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState((prev) => ({
                messageIndex: (prev.messageIndex + 1) % LOADING_MESSAGES.length,
            }))
        }, 2200)
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval)
    }

    render() {
        const message = LOADING_MESSAGES[this.state.messageIndex]

        return (
            <div className="valuation-loader valuation-loader-next" role="status" aria-live="polite" aria-label={message}>
                <div className="valuation-loader-background" aria-hidden>
                    <span className="valuation-loader-grid-line valuation-loader-grid-line-one"></span>
                    <span className="valuation-loader-grid-line valuation-loader-grid-line-two"></span>
                    <span className="valuation-loader-grid-line valuation-loader-grid-line-three"></span>
                </div>
                <div className="valuation-loader-content">
                    <div className="valuation-loader-brand" aria-hidden>
                        <span className="valuation-loader-mark">
                            <img src="/homeindex_logo.svg" alt="" />
                        </span>
                        <span>HomeIndex.ie</span>
                    </div>

                    <div className="valuation-loader-orb" aria-hidden>
                        <span className="valuation-loader-orb-ring"></span>
                        <span className="valuation-loader-orb-core">
                            <img src="/homeindex_logo.svg" alt="" />
                        </span>
                    </div>

                    <div className="valuation-loader-copy">
                        <span className="valuation-loader-kicker">Building your valuation</span>
                        <h1>Reading the market signals</h1>
                    </div>

                    <p className="valuation-loader-message" key={this.state.messageIndex}>
                        {message}
                    </p>

                    <div className="valuation-loader-progress" aria-hidden>
                        <span></span>
                    </div>

                    <div className="valuation-loader-steps" aria-hidden>
                        {LOADING_STEPS.map((step) => (
                            <span key={step}>{step}</span>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default ValuationLoader
